export default __webpack_public_path__ + "static/pedersen-b2413a37e397b97e1b4b269470c3c630.jpg";